export default __webpack_public_path__ + "static/media/canon.d2b9cbf7.png";